import { useRef, useEffect, useCallback } from 'react';
import { isMobile } from 'react-device-detect';

function useLoginWindowPostMessage({ redirectUrl }) {
    const windowRef = useRef(null);

    const getLoginMessage = useCallback(
        event => {
            const { data, origin = '' } = event;
            if (origin === window.location.origin) {
                if (data === 'login_success' && windowRef) {
                    windowRef.current.postMessage('closeWindow', document.location.origin);
                    if (redirectUrl) window.location.href = redirectUrl;
                    else window.location.reload();
                }
            }
        },
        [redirectUrl]
    );

    useEffect(() => {
        if (!isMobile) {
            window.addEventListener('message', getLoginMessage, false);
            return () => {
                window.removeEventListener('message', getLoginMessage, false);
            };
        }
        // eslint-disable-next-line no-use-before-define
    }, [getLoginMessage]);

    return { windowRef };
}

export default useLoginWindowPostMessage;
